import {ComponentPropsFromRoute} from "../../../routers/routers";
import React, {useMemo} from "react";
import {Typography} from "antd";
import {QueueJob} from "../job/queue.job";
import {FilteredData} from "../../common/filtered-data/filtered-data";
import {useFilteredData} from "../../common/filtered-data/hook/filtered-data.hook";
import {queueService} from "../../../services/queue/queue.service";
import {useTranslate} from "../../../hooks/translate.hook";
import {filtersFactory} from "./queue.status.fields";

interface QueueStatusProps extends ComponentPropsFromRoute {
}

export const QueueStatus: React.FC<QueueStatusProps> = ({}) => {

    const t = useTranslate();
    const filters = useMemo(() => filtersFactory(), []);

    const data = useFilteredData(
        request => queueService.getStatus(request)
    );

    return (
        <>
            <Typography.Title level={3}>{t("QUEUE.TITLE")}</Typography.Title>
            <FilteredData
                filters={filters}
                data={data}
                render={value => (
                    <QueueJob key={value.id} job={value} />
                )}
            />
        </>
    )
}